import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AssiggnmentToFlightComponent } from "./assiggnment-to-flight/assiggnment-to-flight.component";
import { AssignmentToDealerComponent } from "./assignment-to-dealer/assignment-to-dealer.component";
import { BillCreateComponent } from "./bill-create/bill-create.component";
import { BillComponent } from "./bill/bill.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { DealerBalanceCreateComponent } from "./dealer-balance-create/dealer-balance-create.component";
import { DealerBalanceComponent } from "./dealer-balance/dealer-balance.component";
import { DealersCreateComponent } from "./dealers-create/dealers-create.component";
import { DealersComponent } from "./dealers/dealers.component";
import { FlightComponent } from "./flight/flight.component";
import { ShippingBalanceCreateComponent } from "./shipping-balance-create/shipping-balance-create.component";
import { ShippingBalanceComponent } from "./shipping-balance/shipping-balance.component";
import { ShippingComponent } from "./shipping/shipping.component";
import { ScannerComponent } from "./scanner/scanner.component";
import { BashToFlightComponent } from "./bash-to-flight/bash-to-flight.component";
import { BillBatchCreateComponent } from "./bill-batch-create/bill-batch-create.component";
import { OrdersComponent } from "./orders/orders.component";
import { BillSummaryShipmentComponent} from "./bill-summary-shipment/bill-summary-shipment.component";
import { BillsToDispatchComponent } from "./bills-to-dispatch/bills-to-dispatch.component";
import { DealerDispatchsComponent } from "./dealer-dispatchs/dealer-dispatchs.component";

const routes: Routes = [
  { path: "", component: DashboardComponent },
  { path: "shipping", component: ShippingComponent },
  { path: "shipping-summary/:shippingId", component: BillSummaryShipmentComponent },  
  { path: "scanner", component: ScannerComponent },  
  { path: "flight", component: FlightComponent },
  { path: "bill", component: BillComponent },
  { path: "orders", component: OrdersComponent },
  { path: "bill-create", component: BillCreateComponent },
  { path: "bill-create/:billId", component: BillCreateComponent },
  { path: "bill-batch-create/", component: BillBatchCreateComponent },
  { path: "assignment/toflight", component: AssiggnmentToFlightComponent },
  { path: "assignment/todealer", component: AssignmentToDealerComponent },
  { path: "assignment/dispatchs", component: BillsToDispatchComponent },  
  { path: "assignment/create-dispatch/:dispatchId", component: DealerDispatchsComponent },
  { path: "assignment/create-dispatch", component: DealerDispatchsComponent },
  { path: "dealers", component: DealersComponent },
  { path: "dealers-create", component: DealersCreateComponent },
  { path: "dealers-create/:dealerId", component: DealersCreateComponent },
  { path: "dealer-balance", component: DealerBalanceComponent },
  { path: "shipping-balance", component: ShippingBalanceComponent },
  { path: "dealer-balance-create", component: DealerBalanceCreateComponent },
  {
    path: "shipping-balance-create",
    component: ShippingBalanceCreateComponent,
  },
  { path: "bash-to-flight", component: BashToFlightComponent },
  { path: "bill-batch-create", component: BillBatchCreateComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
